var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA4InstallerToolbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 59h52V36H12v23zm4-19h44v15H16V40zm45-15h-9v-9H24v9h-9a3 3 0 00-3 3v5h52v-5a3 3 0 00-3-3zm-13 0H28v-5h20v5zm1 19h6v6h-6v-6z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A4_Installer_toolbox.6c4d9561.svg";
export { SvgA4InstallerToolbox as ReactComponent };